export { default as InstitutionList } from "./components/Main";
export type { InstitutionListProps } from "./components/Main";
export { default as InstitutionListPreview } from "./components/Preview";
